import { takeEvery, call, put } from 'redux-saga/effects';
import callAdapter from '@/utils/sagaHelper';
import actions from '../constants';
import DatasetModelsService from '../service';
import {
  fetchDataModelsError,
  fetchDataModelsSuccess,
  fetchDatasetDataModelError,
  fetchDatasetDataModelSuccess,
  updateDatasetDataModelError,
  updateDatasetDataModelSuccess,
} from '../actions';

export function* fetchDataModels({ category }) {
  const { response, error } = yield call(callAdapter, DatasetModelsService.dataModels());

  if (error) {
    yield put(fetchDataModelsError(category, error));
  } else {
    yield put(fetchDataModelsSuccess(category, response.items));
  }
}

export function* fetchDatasetDataModel({ category, code }) {
  const { response, error } = yield call(callAdapter, DatasetModelsService.datasetDataModel(code));

  if (error) {
    yield put(fetchDatasetDataModelError(category, code, error));
  } else {
    yield put(fetchDatasetDataModelSuccess(category, code, response));
  }
}

export function* updateDatasetDataModel({
  category, code, name, dataModelCode,
}) {
  const { response, error } = yield call(
    callAdapter,
    DatasetModelsService.updateDatasetDataModel(code, { code: dataModelCode }),
  );

  if (error) {
    yield put(updateDatasetDataModelError(category, code, name, error));
  } else {
    yield put(updateDatasetDataModelSuccess(category, code, name, response));
  }
}

export default function* dataModelsApi() {
  yield takeEvery(actions.FETCH_DATA_MODELS, fetchDataModels);
  yield takeEvery(actions.FETCH_DATASET_DATA_MODEL, fetchDatasetDataModel);
  yield takeEvery(actions.UPDATE_DATASET_DATA_MODEL, updateDatasetDataModel);
}
